/**
 * 플레이어 화면 구현
 */
import { SbsPlayerGlobal } from '../../../../../common';
import SbsPlayerLogger from '../../../../../utils/logger';

customElements.define(
  'sbs-player-repeat-toggle',
  class extends HTMLElement {
    constructor() {
      super();

      this.activated = false;
    }

    set activated(value) {
      this._activated = value;
      this.render();
    }
    get activated() {
      return this._activated;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        //console.log('## infoType', SbsPlayerGlobal.infoType);

        if (SbsPlayerGlobal.target === 'live') {
          return;
        }
        this.innerHTML = `<div class="controlToggle-repeat${
          this.activated ? ' current' : ''
        }">
		            <button type="button" class="btnText-repeat" aria-label="구간반복${
                  this.activated ? '끄기' : '켜기'
                } aria-expanded="false">
			            <span class="btnToggle-bar"></span>
			            <span class="text-name">구간반복</span>
		            </button>
	            </div>`;
        this.event();
        this.styles();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        this.querySelector('button').addEventListener('click', (event) => {
          this.activated = !this.activated;

          this.dispatchEvent(
            new CustomEvent('button-toggle-repeat', {
              detail: this.activated,
            })
          );
        });
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
      } catch (error) {
        console.log(error);
      }
    }
  }
);
